import type { FC, SVGProps } from 'react';

/**
 * Fusion product icon — verbatim from
 * `wf-audit/src/slices/common/components/icons/FusionIcon.tsx`.
 * Renders the WorkFocus lightning-on-diamond glyph used on the hero
 * tile and the sidebar product-picker.
 */
const FusionIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_fusion)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8512 26.8286H34.7968C35.3344 26.8286 35.5456 27.203 35.2672 27.6638L33.7088 30.2302C33.4304 30.691 33.6416 31.0654 34.1792 31.0654H36.0576C36.5984 31.0654 36.8064 31.4398 36.5152 31.8974L31.6832 39.5166C31.1936 40.2878 30.9216 40.1854 31.0816 39.283L31.7952 35.2542C31.8784 34.7902 31.5584 34.4126 31.088 34.4126H28.8544C28.3712 34.4126 28.08 34.0318 28.2112 33.5646L29.8816 27.5646C29.9936 27.1582 30.432 26.8286 30.8512 26.8286Z"
        fill="var(--brand-yellow)"
      />
      <path
        d="M32.224 46.9982L17.7344 32.5086L32.224 18.019L46.7136 32.5086L32.224 46.9982ZM19.7568 32.5086L32.224 44.9758L44.6912 32.5086L32.224 20.0414L19.7568 32.5086Z"
        fill="var(--brand-yellow)"
      />
      <path
        d="M58.685 29.3664H55.6962C55.677 29.3664 55.6578 29.3728 55.6386 29.3728L35.0018 8.73604C35.0818 8.56004 35.1298 8.36484 35.1298 8.15684V5.16804C35.1298 4.38724 34.4994 3.75684 33.7186 3.75684H30.7298C29.949 3.75684 29.3186 4.39044 29.3186 5.16804V8.15684C29.3186 8.36484 29.3666 8.56004 29.4466 8.73604L8.66896 29.5104H6.13776C5.35696 29.5104 4.72656 30.144 4.72656 30.9216V33.9104C4.72656 34.6912 5.35696 35.3216 6.13776 35.3216H8.96336L29.3858 55.744V58.4768C29.3858 59.2576 30.0162 59.888 30.797 59.888H33.7858C34.5666 59.888 35.197 59.2576 35.197 58.4768V55.6064L55.6354 35.168C55.6546 35.168 55.6738 35.1744 55.693 35.1744H58.6818C59.4626 35.1744 60.093 34.5408 60.093 33.7632V30.7744C60.093 29.9936 59.4626 29.3632 58.6818 29.3632L58.685 29.3664ZM35.005 54.7904C34.7618 54.368 34.3106 54.08 33.7858 54.08H30.797C30.237 54.08 29.757 54.4096 29.5298 54.88L9.79536 35.1456C10.2338 34.9056 10.5378 34.4448 10.5378 33.9104V30.9216C10.5378 30.3072 10.141 29.7888 9.59376 29.5968L29.8978 9.29284C30.1314 9.46244 30.4162 9.56804 30.7266 9.56804H33.7154C34.0258 9.56804 34.3106 9.46244 34.5442 9.29284L54.877 29.6256C54.5154 29.8816 54.2786 30.3008 54.2786 30.7744V33.7632C54.2786 34.24 54.5154 34.656 54.877 34.912L35.0018 54.7872L35.005 54.7904Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M32.9411 9.56787H31.5107V19.5359H32.9411V9.56787Z"
        fill="url(#paint0_linear_fusion)"
      />
      <path
        d="M32.9362 45.9829L31.5059 45.9941L31.5737 54.6371L33.0041 54.6258L32.9362 45.9829Z"
        fill="url(#paint1_linear_fusion)"
      />
      <path
        d="M32.3813 5.30576L5.5293 32.1577L6.51359 33.142L33.3655 6.29005L32.3813 5.30576Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M58.8793 32.1566L32.0273 5.30469L31.0431 6.28898L57.895 33.1409L58.8793 32.1566Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M57.6801 31.6144L30.8281 58.4663L31.8124 59.4506L58.6644 32.5986L57.6801 31.6144Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M5.25546 32.0777L32.1074 58.9297L33.0917 57.9454L6.23976 31.0934L5.25546 32.0777Z"
        fill="var(--brand-blue)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_fusion"
        x1="29.8007"
        y1="18.4352"
        x2="34.6936"
        y2="10.6442"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: 'var(--brand-yellow)' }} />
        <stop offset="1" style={{ stopColor: 'var(--brand-blue)' }} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_fusion"
        x1="33.2204"
        y1="48.2694"
        x2="28.9603"
        y2="55.1403"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: 'var(--brand-yellow)' }} />
        <stop offset="1" style={{ stopColor: 'var(--brand-blue)' }} />
      </linearGradient>
      <clipPath id="clip0_fusion">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FusionIcon;
